import type { Menu } from "types/menu"
import { universalMenuItems } from "./universal"

export const thirdRailMenu: Menu = [
  {
    label: "Overview",
    items: [
      {
        label: "Live",
        icon: "pi pi-monitor",
        to: "/",
      },
      {
        label: "Alerts",
        icon: "pi pi-exclamation-circle",
        to: "/alerts",
      },
    ],
  },
  { separator: true },
  ...universalMenuItems({}),
]
